import { useWizard } from "react-use-wizard";
import { TKeyOfDataWizardBuy, TNumberKeysOfIFillDataWizardBuy } from "../../..";
import FacilityTypeStep from "../../../../../../../shared/wizard/steps/facilityTypeStep";
import buySteps from "../../buySteps";

interface ISelectionByOwnBuyStep_3 {
  isNextStepDisabled: boolean;
  onChange: (data: number[], key: TNumberKeysOfIFillDataWizardBuy) => void;
  data: number[] | null;
  doublePrevStep: boolean;
  onReset: (key: TKeyOfDataWizardBuy[]) => void;
}

const SelectionByOwnBuyStep_3 = ({
  isNextStepDisabled,
  data,
  doublePrevStep,
  onChange,
  onReset,
}: ISelectionByOwnBuyStep_3) => {
  const { goToStep } = useWizard();

  const handlePrevStep = () => {
    goToStep(
      doublePrevStep
        ? buySteps.selectionSteps.buy.step_1
        : buySteps.selectionSteps.buy.step_2
    );
    onReset(["selectedFacilityTypeIds"]);
  };

  const handleNextStep = () => {
    goToStep(buySteps.selectionSteps.buy.step_4);
  };

  const handleChange = (selectedId: number) => {
    if (data?.includes(selectedId)) {
      onChange(
        data.filter((id) => id !== selectedId),
        "selectedFacilityTypeIds"
      );
      return;
    }
    onChange([selectedId], "selectedFacilityTypeIds");
  };

  return (
    <div>
      <FacilityTypeStep
        isNextStepDisabled={isNextStepDisabled}
        onChange={handleChange}
        onNextStep={handleNextStep}
        onPrevStep={handlePrevStep}
        data={data}
        mode="default"
      />
    </div>
  );
};

export default SelectionByOwnBuyStep_3;
